import React, { useState } from 'react';
import styled from 'styled-components';
import ScreenDashboard from './components/ScreenDashboard';
import ScreenFilter from './components/ScreenFilter';
import ScreenTable from './components/ScreenTable';
import NewScreenModal from '../Create';

const ScreenManagementPage = () => {
  const [isNewScreenModalOpen, setIsNewScreenModalOpen] = useState(false);

  return (
    <Container>
      <ScreenDashboard onNewScreen={() => setIsNewScreenModalOpen(true)} />
      <ScreenFilter />
      <ScreenTable />
      <NewScreenModal 
        open={isNewScreenModalOpen} 
        onClose={() => setIsNewScreenModalOpen(false)} 
      />
    </Container>
  );
};

export default ScreenManagementPage;

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
